import React from 'react';

import { Form, Button, ButtonGroup, Row, Col } from 'react-bootstrap';
import { useResizeDetector } from 'react-resize-detector';
import { useForm, Controller } from 'react-hook-form';

import LogsForSpecification from './LogsForSpecification';
import LogsForConcept from './LogsForConcept';
import EditableTextarea from '../Common/EditableTextarea';

import './EngineeringLogs.sass';

const EngineeringLogs = ({
  concepts,
  designSummary,
  designFields,
  openRevision,
  selectRevision,
  saveJournal,
  saveNotes,
  selectConcept,
  selectedConcept,
  selectedRevision,
  showDesignSummary,
  toggleDesignSummary,
  //  loadingFileManager, // is this still needed?
  defaultSpecification,
}) => {
  const { width, ref } = useResizeDetector();
  const [selectedSpecName, setSelectedSpecName] = React.useState(
    defaultSpecification.name
  );
  const { control, handleSubmit } = useForm();

  /* Get specifications options from the concepts */
  const specifications = concepts
    .map((c) => ({
      id: c.specificationId,
      name: c.specificationName,
    }))
    .filter((elem, i, arr) => arr.findIndex((s) => s.id === elem.id) === i)
    .sort((s1, s2) => s1.name >= s2.name);

  const handleSetSelectedSpecName = ({ specInput }) => {
    if (specInput) {
      setSelectedSpecName(specInput);
    }
  };

  return (
    <div className="w-100 d-flex flex-column" ref={ref}>
      <div className="d-flex border py-1 px-2 justify-content-between">
        <div className="flex-grow-1 px-2">
          <strong>ENGINEERING LOGS</strong>

          {/* Specification filter (disabled when a design is selected) */}
          <Form
            className="mb-1"
            onSubmit={handleSubmit(handleSetSelectedSpecName)}
          >
            <Row className="align-items-center">
              <Col xs="auto" className="pe-0">
                <Form.Label column="sm" htmlFor="specInput">
                  Choose Specification:
                </Form.Label>
              </Col>
              <Col xs="auto" className="pe-0">
                <Controller
                  name="specInput"
                  control={control}
                  render={({ field }) => (
                    <Form.Select
                      size="sm"
                      id="specInput"
                      {...field}
                      defaultValue={defaultSpecification.name}
                      disabled={!!selectedConcept}
                    >
                      {specifications.map((s) => (
                        <option value={s.name} key={s.id}>
                          {s.name}
                        </option>
                      ))}
                    </Form.Select>
                  )}
                />
              </Col>
              <Col xs="auto">
                <Button type="submit" size="sm" variant="secondary">
                  View Designs
                </Button>
              </Col>
            </Row>
          </Form>
        </div>

        <div>
          Show Design Summary:{' '}
          <ButtonGroup size="sm">
            <Button
              variant={showDesignSummary === true ? 'primary' : 'secondary'}
              onClick={() => toggleDesignSummary(true)}
            >
              Yes
            </Button>
            <Button
              variant={showDesignSummary === false ? 'primary' : 'secondary'}
              onClick={() => toggleDesignSummary(false)}
            >
              No
            </Button>
          </ButtonGroup>
        </div>
      </div>

      <div className="d-flex flex-grow-1" style={{ minHeight: 0 }}>
        <div className="d-flex flex-grow-1 bg-white flex-column">
          {selectedConcept ? (
            <LogsForConcept
              concept={selectedConcept}
              selectConcept={selectConcept}
              selectedRevision={selectedRevision}
              designFields={designFields}
              selectRevision={selectRevision}
              openRevision={openRevision}
              saveNotes={saveNotes}
              width={showDesignSummary ? width - 300 : width}
            />
          ) : (
            <LogsForSpecification
              concepts={concepts.filter(
                (c) => c.specificationName === selectedSpecName
              )}
              selectedSpecName={selectedSpecName}
              designFields={designFields}
              width={showDesignSummary ? width - 300 : width}
              selectConcept={selectConcept}
            />
          )}
        </div>

        {showDesignSummary && (
          <div className="h-100 flex-shrink-0" style={{ width: '300px' }}>
            <EditableTextarea
              title="Design Summary"
              save={saveJournal}
              identifier="designSummary"
              content={designSummary}
              className="h-100"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default EngineeringLogs;
